import { useMutation } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { fetcher } from "../../../utils/Axios";
import { TIMER } from "../types/CommonTypes";
import { EDIT_TIMER_LABEL_REQUEST } from "../types/RequestTypes";
import removeEmptyKeys from "../../../helpers/removeEmptyKeys";
import { updateCaseSummaryTimerLabelInCache } from "./useGetCaseSummaryQuery";

function editTimerLabel(
  reqBody: EDIT_TIMER_LABEL_REQUEST
): Promise<AxiosResponse<TIMER>> {
  const { caseId, timerId, timerData } = reqBody;
  return fetcher({
    url: `cases/${caseId}/timers/${timerId}/description`,
    method: "PATCH",
    data: removeEmptyKeys(timerData),
  });
}

export default function useEditTimerLabelMutation() {
  return useMutation({
    mutationFn: editTimerLabel,
    onSuccess: (res, req) => {
      if (req.caseId) {
        updateCaseSummaryTimerLabelInCache({
          caseId: req.caseId,
          data: {
            id: res?.data?.id,
            description: res?.data?.description,
          },
        });
      }
    },
  });
}
